import { CabinetBody, CabinetBodyDocument, ElasticSearchResponse } from '@shared/services/elastic-search/models';

export const cabinetBodiesSerializer = (response: ElasticSearchResponse<CabinetBodyDocument>): CabinetBody[] =>
  response.hits.hits.map((hit) => {
    const source = hit._source;
    return {
      images: source.field_images,
      title: source.title?.[0] ?? '',
    };
  });
